export const translations = {
  en: {
    nav: {
      expertise: "Stack",
      history: "Career History",
      projects: "Projects",
    },
    hero: {
      name: "Andrés Flórez",
      role: "Software Developer",
    },
    expertise: {
      title: "Technical Stack",
      mobile: {
        title: "Mobile development",
        description:
          "I have 3+ years of experience in mobile development with Flutter and React Native. I specialize in clean architecture, SOLID principles, and tools like Flutter Bloc, Provider, Redux, and dependency injection. I work with both React Native CLI and Expo, focusing on creating high-quality, scalable, and maintainable mobile apps.",
      },
      js: {
        title: "JavaScript Developer",
        description:
          "I have extensive experience in JavaScript with React, Node.js, and TypeScript. I build dynamic web and mobile applications, using tools like Redux, Context API, RESTful APIs, and GraphQL. I focus on creating reusable components and maintaining clean, efficient, and scalable code.",
      },
    },
    history: {
      title: "Career History",
    },
    projects: {
      title: "Projects",
      readMore: "read more",
    },
  },

  es: {
    nav: {
      expertise: "Stack",
      history: "Historial Profesional",
      projects: "Proyectos",
    },
    hero: {
      name: "Andrés Flórez",
      role: "Desarrollador de Software",
    },
    expertise: {
      title: "Stack Técnico",
      mobile: {
        title: "Desarrollo móvil",
        description:
          "Tengo más de 3 años de experiencia en desarrollo móvil con Flutter y React Native. Me especializo en arquitectura limpia, principios SOLID y herramientas como Flutter Bloc, Provider, Redux e inyección de dependencias. Trabajo con React Native CLI y Expo, creando aplicaciones móviles de alta calidad, escalables y mantenibles.",
      },
      js: {
        title: "Desarrollador JavaScript",
        description:
          "Tengo amplia experiencia en JavaScript con React, Node.js y TypeScript. Desarrollo aplicaciones web y móviles dinámicas utilizando herramientas como Redux, Context API, APIs RESTful y GraphQL. Me enfoco en crear componentes reutilizables y mantener un código limpio, eficiente y escalable.",
      },
    },
    history: {
      title: "Historial Profesional",
    },
    projects: {
      title: "Proyectos",
      readMore: "leer más",
    },
  },
};
